module.exports = "/images/hurricane-alt@3x.png?89754cc9755659aab845b86beab980e1";